import {importProvidersFrom} from "@angular/core";
import {AppComponent} from "./app/app.component";
import {provideRouter, RouterOutlet, withInMemoryScrolling, withRouterConfig} from "@angular/router";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {provideAnimations} from "@angular/platform-browser/animations";
import {bootstrapApplication, BrowserModule} from "@angular/platform-browser";
import {NetworkInterceptor} from "./app/core/interceptors/network-interceptor";
import {HTTP_INTERCEPTORS, HttpBackend, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {AppointmentResolver} from "./app/feature/resolvers/appointment.resolver";
import {AppointmentService} from "./app/feature/services/appointment.service";
import {FactoryIdToCountryMapper} from "./app/feature/services/factory-id-to-country-mapper";
import {HttpService} from "./app/core/services/http.service";
import {routes} from "./app/app.routes";
import {SplashScreenStateService} from "./app/shared/components/splash-screen/splash-screen-state.service";
import {TimeSlotResolverGuard} from "./app/feature/resolvers/time-slot.resolver-guard";
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from "@angular/material/form-field";
import {AppointmentResolverGuard} from "./app/feature/resolvers/appointment.resolver-guard";
import {EmbedModeService} from "./app/feature/services/embed-mode.service";
import {EmbedModeResolver} from "./app/feature/resolvers/embed-mode.resolver";
import {createTranslateLoader} from "./app/app.module";
import {SettingsResolver} from "./app/feature/resolvers/settings.resolver";
import {SettingsService} from "./app/feature/services/settings.service";

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule, FormsModule, TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpBackend]
      }
    }), ReactiveFormsModule, RouterOutlet),
    HttpService,
    EmbedModeService,
    EmbedModeResolver,
    FactoryIdToCountryMapper,
    SettingsService,
    SettingsResolver,
    AppointmentService,
    AppointmentResolver,
    AppointmentResolverGuard,
    TimeSlotResolverGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NetworkInterceptor,
      multi: true,
    },
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes, withInMemoryScrolling()),
    {
      provide:MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {appearance: 'outline'}
    },
    SplashScreenStateService,
  ]
}).catch(err => console.error(err));
